import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPartenairesStats } from '../services/api';

const Partenaires: React.FC = () => {
  const [partenaires, setPartenaires] = useState<any[]>([]);

  useEffect(() => {
    getPartenairesStats().then(r => setPartenaires(r.data));
  }, []);

  return (
    <div>
      <h2 style={{ marginBottom: 20, color: '#333' }}>Partenaires</h2>
      <div className="partenaires-grid">
        {partenaires.map((p: any) => (
          <Link to={`/admin/partenaires/${p.id}`} key={p.id}>
            <div className="partenaire-card">
              <h3>{p.libelle}</h3>
              <div className="partenaire-meta">
                Code: {p.code} | {p.responsable} | {p.adresse} | {p.telephone}
              </div>
              <div className="partenaire-stats-row">
                <div className="partenaire-stat">
                  <div className="value">{p.nbForages}</div>
                  <div className="label">Forages</div>
                </div>
                <div className="partenaire-stat">
                  <div className="value">{p.nbAbonnes?.toLocaleString('fr-FR')}</div>
                  <div className="label">Abonnes</div>
                </div>
                <div className="partenaire-stat">
                  <div className="value">{p.nbFactures?.toLocaleString('fr-FR')}</div>
                  <div className="label">Factures</div>
                </div>
              </div>
              <div style={{ marginTop: 12, display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#777' }}>
                <span>Facture: {p.montantFacture?.toLocaleString('fr-FR')} FCFA</span>
                <span>Paye: {p.montantPaye?.toLocaleString('fr-FR')} FCFA</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Partenaires;
